import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/auth/AuthContext";
import { useTranslation } from "@/i18n";
import { toast } from "sonner";

// Home-screen redemption entry. Reuses the exact same redeemCode() flow as
// Settings (POST /me/redeem-code + immediate entitlement refresh in AuthContext).
export function RedeemCodeDialog({ open, onOpenChange }) {
  const { t } = useTranslation();
  const { redeemCode, formatApiError } = useAuth();
  const [code, setCode] = useState("");
  const [redeeming, setRedeeming] = useState(false);

  const submit = async () => {
    if (!code.trim() || redeeming) return;
    setRedeeming(true);
    try {
      await redeemCode(code.trim());
      setCode("");
      toast.success(t("settings.codeApplied"));
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setRedeeming(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!redeeming) onOpenChange(o); }}>
      <DialogContent className="rounded-2xl sm:max-w-md" data-testid="redeem-dialog">
        <DialogHeader>
          <DialogTitle>{t("settings.redeemCode")}</DialogTitle>
          <DialogDescription>{t("settings.redeemHint")}</DialogDescription>
        </DialogHeader>
        <div className="flex gap-2 pt-1">
          <Input
            value={code}
            onChange={(e) => setCode(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") submit(); }}
            placeholder="ASSIST-XXXXXXXX"
            className="rounded-xl h-12 font-mono-tab flex-1"
            autoFocus
            data-testid="redeem-dialog-input"
          />
          <Button
            className="rounded-xl h-12 px-5 bg-slate-900 hover:bg-slate-800 shrink-0"
            onClick={submit}
            disabled={redeeming || !code.trim()}
            data-testid="redeem-dialog-submit"
          >
            {t("settings.redeem")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
